import { Component, OnInit, ViewChild } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { environment } from '../../../environments/environment';
import { AES } from 'crypto-js';
import { NavigationExtras, Router } from '@angular/router';
import { IonicSelectableComponent } from 'ionic-selectable';
import { UserProfile } from '../../models/user-profile.model';
import { UtilService } from '../../service/util.service';
import { HomeService } from '../home/home.service';
import * as XLSX from 'xlsx';
import { RoleAccess } from '../../models/role-access.model';
import { UserData } from '../../providers/user-data';
@Component({
  selector: 'app-po-auto',
  templateUrl: './po-auto.page.html',
  styleUrls: ['./po-auto.page.scss'],
})
export class PoAutoPage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  dataStock: any[] = [];
  dataPoAuto: any[] = [];
  listMonth:any[]=[];
  counterId :any=0;
  warehouseId : any=0;
  listCounter : any[] = [];
  selectedCounter:any[] = [];
  totalQtyPo:number=0;
  counterName:any='';
  turn_over_stock:number=15;
  turn_over_order:number=18;
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;
  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private utilService: UtilService,
    private homeService: HomeService,
    private alertController:AlertController,
    private userData: UserData,
    private router: Router
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile,access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          window.dispatchEvent(new CustomEvent('user:getmenu'));
          this.selectedCounter=[];
          this.getDataCounter();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  selectCounter(event){
    this.counterId = event.value.id;
    this.dataPoAuto = [];
    this.getDataStock();
  }
  getMonthsInRange(startDateStr: string, endDateStr: string): number[] {
      const start = new Date(startDateStr);
      const end = new Date(endDateStr);
      const result: number[] = [];

      // Normalisasi ke awal bulan
      start.setDate(1);
      end.setDate(1);

      while (start <= end) {
        const month = start.getMonth() + 1; // getMonth() 0–11 → +1 jadi 1–12
        result.push(month);

        // Tambah 1 bulan
        start.setMonth(start.getMonth() + 1);
      }

      return result;
  }

  getDataPoAuto() {
    this.totalQtyPo = 0;
    this.dataPoAuto = [];
    this.listMonth=[];
    const bulanIndonesia = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni','Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
    let newDate = new Date();
    let threeMonthsAgo = new Date(newDate);
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    let tahun = threeMonthsAgo.getFullYear();
    let start_date = tahun+'-'+(threeMonthsAgo.getMonth() + 1).toString().padStart(2, '0')+'-01';
    let lastDayOfLastMonth = new Date(newDate.getFullYear(), newDate.getMonth(), 0);
    let year = lastDayOfLastMonth.getFullYear();
    let month = (lastDayOfLastMonth.getMonth() + 1).toString().padStart(2, '0'); // tambahkan 0 di depan jika < 10
    let day = lastDayOfLastMonth.getDate().toString().padStart(2, '0');
    let formattedDate = `${year}-${month}-${day}`;
    let currentMonth = (newDate.getMonth() + 1).toString().padStart(2, '0');
    const bulan = this.getMonthsInRange(start_date, formattedDate);
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let convertDate = this.utilService.convertDate(newDate);
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let options = {
        "token": this.token,
        "year": convertDate.years,
        "month": convertDate.months,
        "today": todayDate,
        "start_date": start_date,
        "end_date": formattedDate,
        "cashier_id": this.userProfile.cashier_id ? this.userProfile.cashier_id : 0,
        "counter_id": this.counterId
      };

      this.homeService.getDashboardPoAuto(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let salesData: any[] = response.results.data_sales;
        let stockData: any[] = response.results.data_stock;
        let jumlah_hari : any = response.results.jumlah_hari;
        for(let y = 0; y < bulan.length; y++) {
          let bulannam = bulanIndonesia[bulan[y]-1];
          this.listMonth.push(bulannam);
        }
        this.counterId =  response.results.counter_id;
        this.counterName =  response.results.counter_name;
        let settingPO = response.results.setting_po;
        if(response.results.warehouse){
          this.warehouseId =response.results.warehouse.id;
        }
        if(stockData.length > 0) {
          for(let x = 0; x < stockData.length; x++) {
            let pcode = stockData[x].product_id;
            let getStock = stockData.find(z => z.product_id === pcode);
            let stock =0;
            if(getStock){
              stock = getStock[`end_${currentMonth}`];
            }
            let productName = stockData[x].product_name;
            let getSales = [];
            let totalSales = 0;
            let asq =0;
            for(let y = 0; y < bulan.length; y++) {
              let sales1 = salesData.find(z => z.product_id === pcode && z.month==bulan[y]);
              let total_qty =0;
              if(sales1){
                total_qty = parseInt(sales1.total_qty);
              }
              getSales.push(total_qty);
              totalSales+=total_qty;
              asq = totalSales/jumlah_hari;
            }
            if(settingPO){
              this.turn_over_stock =settingPO.turn_over_stock ? parseInt(settingPO.turn_over_stock) : this.turn_over_stock;
              this.turn_over_order = settingPO.turn_over_order ? parseInt(settingPO.turn_over_order) : this.turn_over_order;
            }
            let qty_po = (asq && asq !== 0 && stock / asq <= this.turn_over_stock) ? this.hitungNilai(asq) : 0;
            let turnover_stock = stock/asq;
            this.totalQtyPo += Number(qty_po);
            let data = {
              pcode: pcode,
              name: productName,
              getSales: getSales,
              totalSales: totalSales,
              jumlah_hari:jumlah_hari,
              stock:stock,
              asq : asq,
              turnover_stock :turnover_stock,
              qty_po:qty_po
            }
            this.dataPoAuto.push(data);
            this.dataPoAuto.sort((a, b) => b.qty_po - a.qty_po); 
          }
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  hitungNilai(n22: number): number | string {
    const hasil = Math.ceil((this.turn_over_order * n22) / 3) * 3;
    if(hasil>0){
      return hasil;
    }
    else{
      return 0;
    }
  }
  createPO(){
    //CEK apakah ada barang yang perlu di PO. kalau ada redirect ke form buat PO, kalau tidak ada kasih alert saja.
    if(this.totalQtyPo<=0){
      this.alertPoNotNeeded();
    }
    else{
      let id='secret#'+this.counterId.toString()+'#'+this.warehouseId.toString();
      let myKey = environment.myKey;
      let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
      let navigationExtras: NavigationExtras = {
        queryParams: {
          i: encryptID
        }
      };
      this.navCtrl.navigateForward(['/po-auto/po-auto-create'], navigationExtras);
    }
  }
  async alertPoNotNeeded() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Tidak ada barang yang perlu di PO',
      buttons: [
        {
          text: 'OK',
          handler: () => {
          }
        }
      ]
    });
    await alert.present();
  }
  getDataCounter() {
    let cashier_id = this.userProfile.cashier_id ? this.userProfile.cashier_id : 0;
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token
      };
      this.homeService.getCounterData(cashier_id,options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let cashierData =  response.results.data;
        const allowedIds = this.userProfile.counter_id_list; // array of allowed IDs
        this.listCounter= response.results.counter_data.filter(counter =>
          allowedIds.includes(counter.id)
        );
        if(cashierData){
          this.counterId = cashierData.counter_id;
          let selectedCounter: any = this.listCounter.find(x => x.id ==  this.counterId);
          if(selectedCounter){
            let idx =this.listCounter.indexOf(selectedCounter);
            this.selectedCounter=(this.listCounter[idx]);
          }
          this.getDataStock();
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  getDataStock() {
    this.dataStock = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let newDate = new Date();
      let convertDate = this.utilService.convertDate(newDate);
      let todayDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let dateOfMonth = this.utilService.getFirstAndLastDateofMonth();
      let options = {
        "token": this.token,
        "year": convertDate.years,
        "month": convertDate.months,
        "today": todayDate,
        "start_date": dateOfMonth.startDate,
        "end_date": dateOfMonth.endDate,
        "cashier_id": this.userProfile.cashier_id ? this.userProfile.cashier_id : 0,
        "counter_id": this.counterId
      };
      this.homeService.getDashboardStockData(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let stockData: any[] = response.results.stock_data;
        if(stockData.length > 0) {
          let todayTransactionData: any[] = response.results.today_transaction_data;
          let monthTransactionData: any[] = response.results.month_transaction_data;
          let productData: any[] = response.results.productData;
          for(let x = 0; x < stockData.length; x++) {
            let stockQty = this.getStock(convertDate.months, stockData[x]);
            let pcode: any = stockData[x].pcode;
            let checkTodayTrans: any = todayTransactionData.find(x => x.product_id === pcode);
            let checkMonthTrans: any = monthTransactionData.find(x => x.product_id === pcode);
            let checkProduct :any = productData.find(x=>x.pcode==pcode);
            let data = {
              pcode: stockData[x].pcode,
              name: stockData[x].product_name,
              early: stockQty.early,
              in: stockQty.in,
              todayTransQty: checkTodayTrans ? parseInt(checkTodayTrans.qty) : 0,
              monthTransQty: checkMonthTrans ? parseInt(checkMonthTrans.qty) : 0,
              end: stockQty.end,
              min_stock :checkProduct ? checkProduct.min_stock : 0,
              max_stock :checkProduct ? checkProduct.max_stock : 0,
            }
            this.dataStock.push(data);
          }
          this.getDataPoAuto();
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  getStock(month: any, data: any) {
    let earlyStock = data[`early_${month}`];
    let inStock = data[`in_${month}`];
    let endStock = data[`end_${month}`];
    return {
      early   : earlyStock,
      in      : inStock,
      end     : endStock
    };
  }
   exportToExcel() {
    const element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
    // Hitung lebar maksimal per kolom
    const range = XLSX.utils.decode_range(ws['!ref']!);
    const colWidths = [];
  
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxWidth = 10; // default minimum width
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = ws[cellRef];
  
        if (cell && cell.v != null) {
          const cellValue = cell.v.toString();
          maxWidth = Math.max(maxWidth, cellValue.length);
        }
      }
      colWidths.push({ wch: maxWidth + 2 }); // +2 untuk padding
    }
  
    ws['!cols'] = colWidths; // Set auto-width
  
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const filename = `List PO Auto Counter ${this.counterName}.xlsx`;
  
    XLSX.writeFile(wb, filename);
  }
}